export const PRODUCT_FETCH = "PRODUCT_FETCH"
export const PRODUCT_FETCH_SUCCESS = `${PRODUCT_FETCH}_SUCCESS`
export const PRODUCT_FETCH_FAILURE = `${PRODUCT_FETCH}_FAILURE`
export const PRODUCT_FETCH_CALL = `${PRODUCT_FETCH}_CALL`

export const CHARTS_FETCH = "CHARTS_FETCH"
export const CHARTS_FETCH_SUCCESS = `${CHARTS_FETCH}_SUCCESS`
export const CHARTS_FETCH_FAILURE = `${CHARTS_FETCH}_FAILURE`
export const CHARTS_FETCH_CALL = `${CHARTS_FETCH}_CALL`

export const CARDS_FETCH = "CARDS_FETCH"
export const CARDS_FETCH_SUCCESS = `${CARDS_FETCH}_SUCCESS`
export const CARDS_FETCH_FAILURE = `${CARDS_FETCH}_FAILURE`
export const CARDS_FETCH_CALL = `${CARDS_FETCH}_CALL`
